import { ChildrenProps } from './components/utils';
import { Runtime, streamSpecifierToEventStreamIds } from '@cotera/sdk/core';
import { useAppData } from './stores/org';
import { ProvideEraScopes } from './pages/apps/compiler/macro-expansion/scopes';
import { useWarehouseConnection } from './hooks';
import { useEffect } from 'react';
import { useCommits } from '../v0/components/inner-layout';
import { useToolResolver } from './hooks/use-tools-info';

window.COTERA_RDA_RUNTIME = null;

declare global {
  interface Window {
    COTERA_RDA_RUNTIME: Runtime.RuntimeDataProvider | null;
  }
}

export const RuntimeDataProvider: React.FC<ChildrenProps & {}> = ({
  children,
}) => {
  const eventStreams = useAppData((x) => x.manifestMeta.eventStreams);
  const { data: wc } = useWarehouseConnection();
  const WRITE_SCHEMA = wc?.writeSchema ?? '@@write-schema';
  const commits = useCommits();
  const toolResolver = useToolResolver();

  const data: Runtime.RuntimeDataProvider = {
    '@@cotera-graph-refs': {
      commits: commits.data,
    },
    '@@cotera-system': { WRITE_SCHEMA },
    '@@cotera-entities': {
      WRITE_SCHEMA,
      DEFINITIONS: [],
    },
    '@@cotera-events': {
      CURSORS: [],
    },
    '@@cotera-manifest-event-streams': {
      STREAMS: eventStreams.map((stream) => {
        const { streamId, entityName } = streamSpecifierToEventStreamIds(
          stream.specifier
        );
        return {
          entity_id: entityName,
          event_stream_id: streamId,
        };
      }),
      SINKS: eventStreams.flatMap((stream) => {
        const { streamId, entityName } = streamSpecifierToEventStreamIds(
          stream.specifier
        );
        return Object.entries(stream.sinks).map(([sink_id, { config }]) => ({
          event_stream_id: streamId,
          entity_id: entityName,
          sink_id,
          type: config.t,
        }));
      }),
    },
  };

  useEffect(() => {
    window.COTERA_RDA_RUNTIME = data;

    return () => {
      window.COTERA_RDA_RUNTIME = null;
    };
  });

  const scopes = Runtime.provide(data, toolResolver);
  return <ProvideEraScopes scopes={scopes}>{children}</ProvideEraScopes>;
};
